<template>
  <!-- 这里设置了fix定位，是因为 #default-layout 有一个 width 的处理 -->
  <div class="client-mit-page">
    <!-- <img
      class="head-img"
      v-if="lang === 'da'"
      src="/static/img/mit/btn_tap_to_return_da.png"
    />
    <img
      class="head-img"
      v-else
      src="/static/img/mit/btn_tap_to_return_en.png"
    /> -->
    <div class="watermark-wrapper">
      <img
        class="watermark"
        src="/static/img/mit/KKPOKER_Brand_Logo.png"
        alt=""
      />
    </div>
    <div class="return-tip">{{ $t('register.LAB_MITID_CLIENT_RETURN_TIP') }}</div>
  </div>
</template>

<script>
import { reportMitCallbackData } from "@/api/official";
export default {
  data() {
    return {
      lang: "da",
    };
  },
  created() {
    let registerParams = localStorage.getItem("registerParams");
    this.registerParams = JSON.parse(registerParams);
    console.log("registerParams");
    console.log(this.registerParams);
    let { data = "", lang = "da" } = this.$route.query;
    this.lang = lang;
    // 将data进行base64反解码
    if (data.length) {
      let decodedData = atob(data);
      // 将解码后的数据进行JSON.parse解析
      let parsedData = JSON.parse(decodedData);
      console.log(parsedData);

      if (parsedData.error_description) {
        // mit认证错误
      } else {
        // mit认证成功, 跳转到邮箱提示页
      }
      reportMitCallbackData({
        ...this.$route.query,
        email_verification_data: "",
      });
    } else {
      // 没参数情况下显示错误信息
      this.showMitError = true;
    }
  },
};
</script>

<style lang="less" scoped>
.client-mit-page {
  width: 100vw;
  height: 100vh;
  background-color: #000;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  .watermark-wrapper {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .watermark {
    width: 60%;
    height: auto;
  }
  .return-tip {
    width: 100%;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #1f9d56;
    color: #fff;
    font-size: 34px;
    line-height: 20px;
    letter-spacing: 1px;
  }
}
</style>
